import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { getToken } from "../../utils/getToken";

type Params = {
  timePeriod?: string;
  customStartDate?: string;
  customEndDate?: string;
};

export const useGetTopSalesQuery = (
  params: Params = { timePeriod: "year" }
) => {
  const token = getToken();

  return useQuery({
    queryKey: ["useGetTopSalesQuery", params],
    queryFn: () =>
      axiosInstance
        .get("dashboard/top-sales", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        })
        .then((res) => res.data),

    enabled: !!token,
  });
};
